<template>
  <div class="diagram-line-sec">
    <svg
      class="diagram-line-sec__lines"
      :viewBox="_getSvgViewbox"
      preserveAspectRatio="none"
    >
      <path
        v-for="(line,lineIndex) in lines"
        :key="lineIndex"
        :d="$_getLinePath(line)"
        :style="{stroke:lineColors[lineIndex]}"
      />
    </svg>
    <div
      v-for="(dots,dotsIndex) in lines"
      :key="dotsIndex"
      class="diagram-line-sec_dots"
    >
      <div
        v-for="(dot,dotIndex) in dots"
        :key="dotIndex"
        class="diagram-line-sec_dot-wrapper"
        :class="{active:ingHoverIndex==dotIndex || hasDot}"
      >
        <div
          class="diagram-line-sec_dot"
          :style="[{bottom:$_getDotY(dot)},{color:lineColors[dotsIndex]},{backgroundColor:ingHoverIndex==dotIndex?lineColors[dotsIndex]:dotColors[dotsIndex]}]"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DiagramLineSec",
  props: {
    lines: {
      type: Array,
      default() {
        return [];
      },
    },
    tooltips: {
      type: Object,
      default() {
        return {};
      },
    },
    range: {
      type: Array,
      default() {
        return [];
      },
    },
    lineColors: {
      type: Array,
      default() {
        return [];
      },
    },
    dotColors: {
      type: Array,
      default() {
        return [];
      },
    },
    ingHoverIndex: {
      type: Number,
      default: -1,
    },
    totalHeight: {
      type: Number,
      default: 0,
    },
    hasDot: {
      type: Boolean,
      default: false,
    },
    dataLength: {
      type: Number,
      default: 0,
    },
    smoothSize: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    _getSvgViewbox() {
      return `0 0 ${this._svgViewBoxWidth} ${this.totalHeight}`;
    },
    _svgViewBoxWidth() {
      return window.innerWidth > 767
        ? 100 * this.dataLength
        : 30 * this.dataLength;
    },
  },
  methods: {
    $_getLinePath(line) {
      let min = this.range[1];
      let range = this.range[0] - min;
      let gap = window.innerWidth > 767 ? 50 : 15;
      let delta =
        window.innerWidth > 767 ? this._svgViewBoxWidth / this.dataLength : 30;
      let path_d = `M ${gap} ${
        this.totalHeight - ((line[0] - min) / range) * this.totalHeight
      }`;
      if (line === 0) return;
      line.forEach((dot, k) => {
        if (k == 0) return;
        path_d += `C ${gap + (k - 1) * delta + this.smoothSize} ${
          this.totalHeight - ((line[k - 1] - min) / range) * this.totalHeight
        } ${gap + k * delta - this.smoothSize} ${
          this.totalHeight - ((dot - min) / range) * this.totalHeight
        } ${gap + k * delta} ${
          this.totalHeight - ((dot - min) / range) * this.totalHeight
        }`;
      });
      return path_d;
    },
    $_getDotY(dot) {
      let min = this.range[1];
      let range = this.range[0] - min;
      return `${((dot - min) / range) * this.totalHeight}px`;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/diagram-line-sec";
</style>